import React from "react";

const NodeJs = () => {
  return <h1>NodeJs page content</h1>;
};

export default NodeJs;